// import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './Components/Footer';
import Home from './Components/Home';
import Layout from './Components/Layout';
import Error from './Components/Error';
import About from './Components/About';
import BicycleDetail from './Components/BicycleDetail';
import BicycleLeft from './Components/BicycleLeft';
import BicycleRight from './Components/BicycleRight';
import Bicycle from './Components/Bicycle';
import BlogDetailsLeft from './Components/BlogDetailsLeft';
import BlogDetailsRight from './Components/BlogDetailsRight';
import BlogDetails from './Components/BlogDetails';
import BlogLeft from './Components/BlogLeft';
import BlogRight from './Components/BlogRight';
import Blog from './Components/Blog';
import Booking from './Components/Booking';
import ComingSoon from './Components/ComingSoon';
import Contact from './Components/Contact';
import Faqs from './Components/Faqs';
import Gallery from './Components/Gallery';

function App() {
  return (
    <>
    <BrowserRouter basename='/tm/react/bycycle'>
      <Layout/>
      <Routes>
        <Route path='/' element={<Home/>}></Route>
        <Route path='/404' element={<Error/>}></Route>
        <Route path='/about' element={<About/>}></Route>
        <Route path='/bicycle-detail' element={<BicycleDetail/>}></Route>
        <Route path='/bicycle-left' element={<BicycleLeft/>}></Route>
        <Route path='/bicycle-right' element={<BicycleRight/>}></Route>
        <Route path='/bicycle' element={<Bicycle/>}></Route>
        <Route path='/blog-details-left' element={<BlogDetailsLeft/>}></Route>
        <Route path='/blog-details-right' element={<BlogDetailsRight/>}></Route>
        <Route path='/blog-details' element={<BlogDetails/>}></Route>
        <Route path='/blog-left' element={<BlogLeft/>}></Route>
        <Route path='/blog-right' element={<BlogRight/>}></Route>
        <Route path='/blog' element={<Blog/>}></Route>
        <Route path='/booking' element={<Booking/>}></Route>
        <Route path='/coming-soon' element={<ComingSoon/>}></Route>
        <Route path='/contact' element={<Contact/>}></Route>
        <Route path='/faqs' element={<Faqs/>}></Route>
        <Route path='/gallery' element={<Gallery/>}></Route>
      </Routes>
      <Footer/>
    </BrowserRouter>
    </>
  );
}

export default App;
